// Spanish

export default {

  component: {
    jobAdList: {
      title: 'Puestos de trabajo abiertos',
      jobs: 'jobs',
      noJobAds: 'Actualmente no hay puestos de trabajo abiertos.',
    },

    jobAdCard: {
      openUntil: date => `Abierto hasta ${date}`,
    },

    jobAdGreetings: {
      thankYou: 'Gracias.',
      readyInfo: 'Se ha recibido tu solicitud y el selector de personal se pondrá en contacto contigo en breve.',
      luck: '¡Buena suerte!',
    },

    jobAdSeeYou: {
      title: 'Gracias.',
      description: 'Tu solicitud ha sido guardada y hemos enviado un enlace para continuar la solicitud más adelante.',
    },

    unpublished: {
      title: 'Sin publicar',
      info: 'El anuncio de empleo aún no se ha publicado.',
    },
  },

  page: {},

}
